<div class="row tertiaty-buttons task m-t-md" [class.panel-open]="panelShow">
  <div class="col-6 button-box small">
    <a
      href="javascript:void(0)"
      attr.aria-expanded="{{ filterPanelShow || false }}"
      [ngClass]="{ open: filterPanelShow, disabled: isP10MCustomer }"
      (click)="
        panelShow = true;
        filterPanelShow = !filterPanelShow;
        sortPanelShow = false;
        updateFilterText()
      "
      id="cta-default-133"
    >
      <span class="center" [attr.aria-label]="filterText">
        <i class="fa fa-filter"></i>
        <br />{{ filterText }}</span
      >
    </a>
  </div>
  <div class="col-6 button-box small">
    <a
      href="javascript:void(0)"
      attr.aria-expanded="{{ sortPanelShow || false }}"
      [ngClass]="{ open: sortPanelShow }"
      (click)="
        panelShow = true;
        sortPanelShow = !sortPanelShow;
        filterPanelShow = false;
        updateFilterValue()
      "
      id="cta-default-135"
    >
      <span class="center" [attr.aria-label]="contentData?.sort">
        <i class="fa fa-sort"></i>
        <br />{{ contentData?.sort }}</span
      >
    </a>
  </div>
</div>
<div class="filter-panel" [hidden]="!filterPanelShow" *ngIf="filterCategories?.length > 0">
  <div class="inner-panel">
    <p-accordion
      id="p-accordion-default-29"
      (onOpen)="onTabOpen($event.index)"
      (onClose)="onTabClose($event.index)"
    >
      <div class="p-accordion p-reset">
        <div *ngFor="let filter of filterCategories; let ind = index">
          <p-accordionTab
            *ngIf="!(filter?.displayName === categoryConstantValue && isAccessoryDetailPage)"
            class="ng-tns-c3-0"
            [selected]="filter?.displayName === selectedFilterDisplayValue"
            id="p-accordionTab-default-38_{{ ind }}"
          >
            <p-header>
              <h6 id="category-name_{{ ind }}" class="title">{{ filter?.displayName }}</h6>
              <span
                *ngIf="filter?.displayName.toLowerCase() === categoryConstantValue"
                [class.d-none]="showCategoryLimitText"
                >{{ contentData?.categorySelectionLimit }}</span
              >
            </p-header>
            <div class="p-content p-content-full">
              <div
                *ngIf="filter?.filterOptions?.length < searchEnableCount; else displaySearchData"
              >
                <section
                  *ngFor="let option of filter?.filterOptions; let idx = index"
                  [class.m-t-md]="idx !== 0"
                >
                  <tmo-checkbox
                    [name]="option?.displayName"
                    [id]="'type' + option?.displayName"
                    [(ngModel)]="option.isSelected"
                    [checked]="option.isSelected"
                    (change)="selectedValue(option, option?.value, filter?.displayName)"
                    [checkboxTitle]="filter?.displayName"
                    [disabled]="
                      filter?.displayName.toLowerCase() === categoryConstantValue &&
                      !option.isSelected &&
                      filterCategorySelectionCount === categorySelectionLimit
                    "
                  >
                    {{
                      filter?.displayName === priceRangeValue
                        ? '$' + option?.displayName
                        : option?.displayName
                    }}
                  </tmo-checkbox>
                </section>
              </div>
              <ng-template #displaySearchData>
                <div class="search-box search">
                  <input
                    id="category-search-text_{{ ind }}"
                    type="text"
                    class="form-control"
                    [(ngModel)]="searchTerm"
                    (ngModelChange)="search(ind)"
                    placeholder="Search By Category"
                  />
                  <a
                    id="category-search"
                    aria-label="Clickable action"
                    class="hover-magenta search-icon"
                    href="javascript:void(0)"
                  >
                    <i class="fa fa-search def"></i>
                  </a>
                </div>
                <div *ngIf="filter?.filteredData" class="m-t-xl">
                  <div
                    *ngFor="let option of filter?.filteredData; let idx = index"
                    [class.m-t-md]="idx !== 0"
                  >
                    <tmo-checkbox
                      [name]="option?.displayName"
                      [id]="'type' + option?.displayName"
                      [(ngModel)]="option.isSelected"
                      [checked]="option.isSelected"
                      [checkboxTitle]="filter?.displayName"
                      [disabled]="
                        filter?.displayName.toLowerCase() === categoryConstantValue &&
                        !option.isSelected &&
                        filterCategorySelectionCount === categorySelectionLimit
                      "
                      (change)="selectedValue(option, option?.value, filter?.displayName)"
                      >{{ option?.displayName }}
                    </tmo-checkbox>
                  </div>
                </div>
                <div *ngIf="!filter?.filteredData" class="m-t-xl">
                  <div
                    *ngFor="let option of filter?.filterOptions; let idx = index"
                    [class.m-t-md]="idx !== 0"
                  >
                    <tmo-checkbox
                      [name]="option?.displayName"
                      [id]="'type' + option?.displayName"
                      [(ngModel)]="option.isSelected"
                      [checked]="option.isSelected"
                      [checkboxTitle]="filter?.displayName"
                      [disabled]="
                        filter?.displayName.toLowerCase() === categoryConstantValue &&
                        !option.isSelected &&
                        filterCategorySelectionCount === categorySelectionLimit
                      "
                      (change)="selectedValue(option, option?.value, filter?.displayName)"
                      >{{ option?.displayName }}
                    </tmo-checkbox>
                  </div>
                </div>
              </ng-template>
            </div>
          </p-accordionTab>
        </div>
      </div>
    </p-accordion>
  </div>
</div>

<div class="sort-panel" [hidden]="!sortPanelShow" *ngIf="sortCategories?.length > 0">
  <div class="inner-panel">
    <label class="form-label m-t-md" *ngFor="let sortCriterion of sortCategories; let ind = index">
      <span class="radio">
        <input
          type="radio"
          name="co-radio_sample"
          (click)="applySort(sortCriterion?.displayName, sortCriterion?.value)"
          [checked]="sortCriterion?.value === selectedSort"
          attr.aria-label="{{ sortCriterion?.displayName }}"
          id="btn-radio-coradiosample-2_{{ ind }}"
          attr.aria-title="{{ sortCriterion?.displayName }}"
        />
        <span class="radio-mask"></span>
      </span>
      <p id="display-name_{{ ind }}" class="content small">{{ sortCriterion?.displayName }}</p>
    </label>
  </div>
</div>
